import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import { OverlayPanel } from "primereact/overlaypanel";
import { HEADER_INDEX } from "../../../constants/app-constants";
const DropdownMultiSelectWithTitle = forwardRef(({ props, onChange, value }, ref) => {
  const initValue = () => {
    if (value && value.length > 0 && props.items) {
      const initialSelectedItems = {};
      value.forEach((item) => {
        if (item.name && item.value && props.items[item.name]) {
          initialSelectedItems[item.name] = item.value;
        }
      });
      return initialSelectedItems;
    }
    return {};
  };

  const [valueState, setValueState] = useState(value ?? []);
  const [selectedItems, setSelectedItems] = useState({});
  const [visibleTitles, setVisibleTitles] = useState({});
  const openDropdown = useRef(false);
  const inputRef = useRef(null);
  useImperativeHandle(ref, () => ({
    handleClear,
  }));

  const toggleTitleVisibility = (title) => {
    setVisibleTitles((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const handleInputClick = (e) => {
    openDropdown.current.toggle(e);
  };

  const handleClear = () => {
    onChange(null);
  };

  const transKeytoValue = (keyData, source) => {
    const result = {};
    for (const [key, values] of Object.entries(keyData)) {
      result[key] = values.map((value) => {
        const found = source[key].find((item) => item.key === value);
        return found ? found.value : value;
      });
    }
    return result;
  };

  const handleChangeSelectedItem = (selectItem) => {
    const value = Object.entries({ ...selectedItems, ...selectItem }).map(([name, value]) => ({
      name,
      value,
    }));
    onChange(value);
  };

  useEffect(() => {
    const selectedValues = initValue();
    setSelectedItems(selectedValues);
    const result = transKeytoValue(selectedValues, props.items);
    setValueState(Object.values(result).flat());
  }, [value]);

    const handleOverlayShow = () => {
    if (openDropdown.current) {
      const overlayElement = openDropdown.current.getElement();
      if (overlayElement) {
        const sidebar = document.querySelector(".p-sidebar-left");
        if (sidebar) {
          overlayElement.style.zIndex = `${HEADER_INDEX + 2}`;
        } else {
          overlayElement.style.zIndex = `${HEADER_INDEX - 1}`;
        }
    }
    }
  };

  const handleOverlayHide = () => {
    if (openDropdown.current) {
      const overlayElement = openDropdown.current.getElement();
      if (overlayElement) {
        overlayElement.style.zIndex = '';
      }
    }
  };

  return (
    <div className="relative">
      <div ref={inputRef} className="relative w-full flex custom-dropdown-container">
        <InputText
          className="keduall-form dropdown-input p-dropdown z-1 keduall-typography text-default-txt text-ellipsis custom-input keduall-typography text-16-semibold-600 custom-placeholder"
          type="text"
          value={valueState.join(", ")}
          onClick={handleInputClick}
          readOnly
          placeholder={Object.values(props.items).flat()[0]?.value ?? props.placeholder}
          tooltip={valueState.join(",")}
          tooltipOptions={{
            className: "keduall-tooltip",
            position: "bottom",
          }}
        />
        {valueState.length > 0 && (
          <div className="absolute z-5 flex flex-row keduall-form dropdown-input group-two-icon gap-3">
            <div className="flex keduall-typography text-16-normal-400 text-default-txt">({valueState.length})</div>
            <Button icon="pi pi-times flex" className="p-button-text keduall-form dropdown-input flex w-max icon" onClick={handleClear} />
          </div>
        )}
        <i className="pi cursor-pointer pi-angle-down keduall-form dropdown-input icon-angle-down-small absolute z-4 flex" onClick={handleInputClick}></i>
      </div>
      <OverlayPanel onShow={handleOverlayShow} onHide={handleOverlayHide} ref={openDropdown} appendTo={inputRef.current} className="left-0 top-100 w-webkit-fill-available mt-2">
        <div className="p-dropdown-panel keduall-form dropdown-input p-075 w-webkit-fill-available custom-dropdown-label p-dropdown overflow-hidden flex flex-column gap-075 pr-0">
          <div className="m-2 mr-0 w-webkit-fill-available keduall-scrollbar overflow-y-scroll">
            {Object.keys(props.items).map((title, index) => (
              <div key={index} className="w-full">
                <div key={title} className="kedual-dropdown-title-contain p-2 mb-2 keduall-typography text-default-txt w-full">
                  <div className="w-full relative pr-5" onClick={() => toggleTitleVisibility(title)} style={{ cursor: "pointer", fontWeight: "bold" }}>
                    {title.toUpperCase()}
                    {visibleTitles[title] ? (
                      <i className="pi cursor-pointer pi-angle-up keduall-form dropdown-input top-0 right-0 icon-angle-down-small absolute z-4 flex"></i>
                    ) : (
                      <i className="pi cursor-pointer pi-angle-down keduall-form dropdown-input top-0 right-0 icon-angle-down-small absolute z-4 flex"></i>
                    )}
                  </div>
                </div>
                {visibleTitles[title] && (
                  <div className="w-full mb-2 p-2">
                    <SelectButton
                      className="flex-wrap keduall-buttons button-outlined-default-small-primary-button-group flex-width keduall-typography text-14-semibold-600 text-default flex gap-1 animate__animated animate__zoomIn animate__faster"
                      value={selectedItems[title] || []}
                      onChange={(e) => handleChangeSelectedItem({ [title]: e.value })}
                      optionLabel={props.labelKey}
                      optionValue={props.valueKey}
                      options={props.items[title]}
                      multiple
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </OverlayPanel>
    </div>
  );
});

export default DropdownMultiSelectWithTitle;
